(function() {
    'use strict';

    angular
        .module('etrrbApp')
        .controller('EtrrbCancelDialogController', EtrrbCancelDialogController);

    EtrrbCancelDialogController.$inject = ['$scope', '$uibModalInstance', 'ETrrbService', 'bookletNum'];

    function EtrrbCancelDialogController ($scope, $uibModalInstance, ETrrbService, bookletNum) {
    	var etrrbCancelDialogCtr = this;
    	etrrbCancelDialogCtr.cancel= cancel;
    	etrrbCancelDialogCtr.ok = ok;
	    function ok() {
	    	$scope.loading = true;
	    	ETrrbService.get({
				uri : 'cancel-receipt-ettrb',
				bookletNum: bookletNum
			}, function(result) {
				$scope.addAlert('Hủy thành công.' + result.cancelDate,'info');
				$scope.loading = false;
			}, function(error) {
				$scope.addAlert('Hủy không thành công. Vui lòng kiểm tra lại','danger');
				$scope.loading = false;
			});
	    	$uibModalInstance.close(true);
	    };
	    
	    function cancel() {
		   $uibModalInstance.dismiss(false);
	    };
    }
})();
